<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center">
            <router-link style="text-decoration: none;" :to="{ name: 'Dashboard'}">
              <b class="title primary white--text">
                Manage Portfolio
              </b>
            </router-link>
          </v-toolbar-title>
          <v-spacer />
          <v-select
            solo
            clearable
            v-model="selectedCustomer"
            :items="getPortfolioCustomers"
            label="Buyers"
          >
          </v-select>
          <v-spacer />
          <v-select
            solo
            clearable
            v-model="statusFilter"
            :items="['IN PROGRESS', 'CANCELLED', 'BILLED', 'ALL']"
            label="Filter"
          >
          </v-select>
          <!-- class="status-filter" -->
          <v-spacer></v-spacer>
          <v-btn outlined @click="addPortfolioDialog()">
            <v-icon left color="teal">add</v-icon> New Portfolio
          </v-btn>
        </v-toolbar>

        <v-data-table
          :headers="portfolioHeader"
          :items="portfoliosByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-menu bottom right offset-y :close-on-content-click="false">
                <v-btn class="mx-0" slot="activator" icon dark>
                  <v-icon color="primary">more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-group :prepend-icon="'picture_as_pdf'" no-action>
                    <template v-slot:activator>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>Actions</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>

                    <v-list-tile
                      v-if="props.item['portfolioHistory']"
                      @click="openHistory(props.item)"
                      color="primary"
                    >
                      <v-list-tile-avatar>
                        <v-icon color="primary">history</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Portfolio History</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                      v-if="props.item['status'] == 'IN PROGRESS'"
                      @click="editPortfolio(props.item)"
                    >
                      <v-list-tile-avatar>
                        <v-icon color="primary">edit</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Edit Portfolio</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                      v-if="props.item['status'] == 'IN PROGRESS'"
                      @click="editPortfolio(props.item)"
                    >
                      <v-list-tile-avatar>
                        <v-icon color="primary">edit</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Return Items</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="deletePortfolio(props.item)">
                      <v-list-tile-avatar>
                        <v-icon color="primary">delete</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Delete Portfolio</v-list-tile-title>
                    </v-list-tile>
                  </v-list-group>
                </v-list>
              </v-menu>
            </td>
            <td>
              <v-icon
                :disabled="
                  props.item['status'] == 'CANCELLED' ||
                  props.item['status'] == 'BILLED' ||
                  (getCustomerName(props.item.buyerId) == 'DELETED CUSTOMER'
                    ? isShopUserExists(props.item.shopPortfolioUserId)
                      ? false
                      : true
                    : false)
                "
                @click="openProd(props.item)"
                color="primary"
                >remove_red_eye</v-icon
              >
            </td>
            <td>
              <b>{{ props.item["portfolioNumber"] }}</b>
            </td>
            <td>
              <b>{{ new Date(props.item.date).toLocaleDateString("en-GB") }}</b>
            </td>

            <td>
              <b>{{
                props.item["invoiceDate"]
                  ? new Date(props.item.invoiceDate).toLocaleDateString("en-GB")
                  : ""
              }}</b>
            </td>
            <td>
              <b v-if="props.item.buyerId">{{
                getCustomerName(props.item.buyerId)
              }}</b>
              <b v-else-if="isShopUserExists(props.item.shopPortfolioUserId)">{{
                getShopUserName(props.item.shopPortfolioUserId)
              }}</b>
              <b v-else>
                <v-btn @click="addShopUser(props.item)">{{
                  props.item.shopPortfolioUserName
                }}</v-btn>
                <br />
                <div>New Customer. Click To Create Buyer.</div>
              </b>
            </td>
            <td>
              <b>{{ props.item["status"] }}</b>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- Start Product Transfer Dialog -->
    <v-dialog v-model="portfolioDialog" persistent fullscreen>
      <v-card persistent>
        <v-card-title class="primary white--text">
          <!-- <span class="headline">Create Portfolio</span> -->
          <span class="headline" v-if="isEdit">Edit Portfolio</span>
          <span class="headline" v-else>Create Portfolio</span>
          <v-spacer />
          <v-btn large icon @click="portfolioDialog = false" flat>
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-switch
                  :disabled="isEdit"
                  v-model="isBuyer"
                  :label="`${
                    isBuyer ? 'Sale Portfolio' : 'Purchase Portfolio'
                  }`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  :disabled="isEdit"
                  v-model="multiFirm"
                  @change="restructureProductList()"
                  :label="`Multi-firm`"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-select
                  dense
                  :disabled="multiFirm"
                  :items="firmsByBrand"
                  label="Select Firm"
                  v-model="selectedFirm"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-select
                  v-bind:items="isBuyer ? buyersByBrand : sellersByBrand"
                  v-model="selectedBuyer"
                  :label="
                    isBuyer ? 'Select or add Buyer' : 'Select or add Seller'
                  "
                  autocomplete
                  :disabled="isEdit"
                  item-text="name"
                  return-object
                  @keyup.native.enter="addCustomer"
                >
                </v-select>
              </v-flex>

              <v-flex xs12 sm2 md2>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerPortfolio"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="date"
                    label="Portfolio Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="date"
                    @input="datepickerPortfolio = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm2 md2>
                <v-text-field
                  v-model="portfolioNumber"
                  prefix="#"
                  label="Serial Number"
                  placeholder="Enter Serial Number"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-layout
                  wrap
                  v-for="(item, index) in items"
                  :key="index + item.productId"
                  :style="
                    item.isReturn
                      ? 'background: #f7c4c4;'
                      : 'background: #c5f7c4;'
                  "
                >
                  <v-flex xs1 sm1 md1 style="padding-left: 20px">
                    <v-checkbox
                      v-model="item.selected"
                      v-if="!item.isReturn"
                      color="indigo"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="display: inline-flex">
                    <v-select
                      dense
                      autocomplete
                      item-text="name"
                      :item-value="'name'"
                      :items="productListByBrand"
                      label="Product Name"
                      v-model="item.productName"
                      @change="restructureProductList(index)"
                    ></v-select>
                  </v-flex>
                  <v-flex xs1 sm1 md1>
                    <v-text-field
                      v-if="item.productName"
                      type="number"
                      v-model.number="item.quantity"
                      label="Quantity"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs1 sm1 md1 v-if="isJewlBusiness">
                    <v-text-field
                      v-if="item.productName"
                      type="number"
                      v-model.number="item.purity"
                      label="Purity"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs2 sm2 md2>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="datepicker1[index]"
                      :nudge-right="40"
                      v-if="item.productName"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="item.date"
                        :label="item.isReturn ? 'Return Date' : 'Sell Date'"
                        v-if="item.productName"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="item.date"
                        v-if="item.productName"
                        @input="datepicker1[index] = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <!-- <v-flex xs2 sm2 md2 >
                      <v-select
                      v-if="item.productName" 
                        dense
                        item-text="text"
                        item-value="value"
                        :items="units"
                        label="Select unit"
                        v-model="item.unit"
                      ></v-select>
                    </v-flex> -->
                  <v-flex xs1 sm1 md1>
                    <v-text-field
                      v-if="item.productName"
                      type="number"
                      v-model.number="item.rate"
                      label="Rate"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs1 sm1 md1 v-if="isJewlBusiness">
                    <v-text-field
                      v-if="item.productName"
                      type="number"
                      v-model.number="item.grossWeight"
                      label="Gross Weight"
                    >
                    </v-text-field>
                  </v-flex>
                  <!-- <v-flex xs1 sm1 md1>
                       <v-switch
                        v-model="item.isReturn"
                         v-if="item.productName"
                        :label="`${item.isReturn ? 'Return' : 'Sale'}`"
                      ></v-switch>
                    </v-flex> -->
                  <!-- <v-flex xs1 sm1 md1>
                      <v-text-field v-if="item.productName"  type="number" :value="(item.rate ? Number.parseFloat(item.rate) : 0 ) * (item.rate ? Number.parseFloat(item.quantity) : 0 )" :disabled="true" label="Total">
                      </v-text-field>
                    </v-flex> -->
                  <v-flex xs2 sm2 md2>
                    <v-btn
                      icon
                      color="primary"
                      v-if="index == items.length - 1 && item.productName"
                      @click="addProd()"
                    >
                      <v-icon>add_circle</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="primary"
                      @click="removeProd(index)"
                      v-if="item.productName"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs1 sm1 md1 style="display: inline-flex">
                    <v-btn
                      flat
                      color="primary"
                      v-if="item.productName && !item.isReturn"
                      @click="addProd(item, index)"
                    >
                      Return
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" @click="combinePortfolio()"
            >Combine Selected Items</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="portfolioDialog = false" flat
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            :disabled="
              !items.length ||
              !selectedBuyer ||
              !items[0].productId ||
              (multiFirm ? false : !selectedFirm)
            "
            @click="addPortfolio()"
            flat
            >{{ isEdit ? "Save" : "Create" }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="invoicePortfolio"
      width="1200"
      v-if="selectedPortfolio && selectedPortfolio['.key']"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Portfolio details:-
          <!-- {{selectedPortfolio['.key']}} -->
        </v-card-title>
        <v-card-text>
           <v-checkbox
              v-model="selectAll"
              color="indigo"
              label="Select All"
            ></v-checkbox>
          <v-data-table
            :headers="productHeaderCreateInvoice"
            :items="selectedPortfolio.items"
            class="elevation-1 dashboardHead"
          >
            <template slot="items" slot-scope="props">
              <tr
                :style="
                  props.item.isReturn
                    ? 'background: #f7c4c4;'
                    : 'background: #c5f7c4;'
                "
              >
                <td>
                  <v-checkbox
                    v-model="props.item.selected"
                    color="indigo"
                    hide-details
                  ></v-checkbox>
                </td>
                <td>
                  <b>{{ props.item["productName"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["quantity"] }}</b>
                </td>
                <td v-if="isJewlBusiness">
                  <b>
                    <v-text-field
                      type="number"
                      v-model.number="props.item.purity"
                      label="Purity"
                    ></v-text-field>
                  </b>
                </td>
                <!-- <td>
                  <b>{{ props.item.unit }}</b>
                </td> -->
                <td v-if="isJewlBusiness">
                  <b>{{ props.item.grossWeight }}</b>
                </td>
                <td>
                  <b>{{
                    new Date(props.item.date).toISOString().substr(0, 10)
                  }}</b>
                </td>
                <td>
                  <b
                    ><v-text-field
                      type="number"
                      v-model.number="props.item.rate"
                      label="Product Rate"
                    ></v-text-field
                  ></b>
                </td>
                <td>
                  <v-btn
                    color="primary"
                    text
                    @click="fetchLatestRate(props.item)"
                    >Fetch Rate</v-btn
                  >
                </td>
              </tr>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="invoicePortfolio = false"
            >Back</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="createInvoice()"
            >Create Invoice
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="portfolioHistory"
      width="1200"
      v-if="selectedPortfolio && selectedPortfolio['.key']"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Portfolio History:-
          <!-- {{selectedPortfolio['.key']}} -->
        </v-card-title>
        <v-card-text>
          <template>
            <v-stepper v-model="historyStep" vertical>
              <template v-for="(item, index) in selectedPortfolio.portfolioHistory">
                <v-stepper-step :step="index + 1" :key="item['.key']">
                  <v-link @click="historyStep = index + 1">{{
                    new Date(item["date"]).toLocaleDateString("en-GB") +
                    (item["type"] == "INVOICE" ? "  -  Invoice created" : "")
                  }}</v-link>
                </v-stepper-step>

                <v-stepper-content :step="index + 1" :key="index">
                  <v-card class="mb-12 invoice-stepper">
                    <v-layout row wrap style="padding: 30px">
                      <v-flex xs12 sm4 md4> </v-flex>
                      <v-flex xs12 sm4 md4> </v-flex>
                      <v-flex xs12 sm4 md4> </v-flex>
                      <v-flex xs12 sm12 md12>
                        <h2
                          style="text-decoration: underline; text-align: center"
                        >
                          Product List
                        </h2>
                        <template>
                          <v-data-table
                            :headers="productInvoiceHeader"
                            :items="item.items"
                            class="elevation-1 dashboardHead"
                          >
                            <template slot="items" slot-scope="props">
                              <tr
                                :style="
                                  props.item.isReturn
                                    ? 'background: #f7c4c4;'
                                    : 'background: #c5f7c4;'
                                "
                              >
                                <td>
                                  <b>{{ props.item["productName"] }}</b>
                                </td>
                                <td>
                                  <b>{{ props.item["quantity"] }}</b>
                                </td>
                                <td v-if="isJewlBusiness">
                                  <b>{{ props.item["purity"] }}</b>
                                </td>
                                <!-- <td>
                                  <b>{{ props.item.unit }}</b>
                                </td> -->
                                <td v-if="isJewlBusiness">
                                  <b>{{ props.item.grossWeight }}</b>
                                </td>
                                <td>
                                  <b>{{
                                    new Date(props.item.date)
                                      .toISOString()
                                      .substr(0, 10)
                                  }}</b>
                                </td>
                                <td>
                                  <b
                                    ><v-text-field
                                      type="number"
                                      v-model.number="props.item.rate"
                                      label="Product Rate"
                                    ></v-text-field
                                  ></b>
                                </td>
                                <td>
                                  <v-btn
                                    color="primary"
                                    text
                                    @click="fetchLatestRate(props.item)"
                                    >Fetch Rate</v-btn
                                  >
                                </td>
                              </tr>
                            </template>
                            <template slot="no-data">No Items</template>
                          </v-data-table>
                        </template>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-stepper-content>
              </template>
            </v-stepper>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="portfolioHistory = false">Back</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
export default {
  data() {
    return {
      productsToPortfolio: [],
      items: [],
      selectAll : false,
      isEdit: false,
      portfolioDialog: false,
      isBuyer: true,
      selectedCustomer: null,
      invoicePortfolio: false,
      multiFirm: false,
      historyStep: 1,
      selectedPortfolio: null,
      selectedBuyer: null,
      selectedFirm: null,
      date: new Date().toISOString().substr(0, 10),
      datepickerPortfolio: false,
      statusFilter: "ALL",
      portfolioNumber: null,
      portfolioHistory: false,
      modalMode: null,
      floorName: null,
      tableName: null,
      datepicker1: {},
      isCallAdded: false,
      tableList: [],
      portfolioHeader: [
        { text: "Action", value: "edit" },
        { text: "View", value: "view" },
        { text: "Serial Number", value: "portfolioNumber" },
        { text: "Portfolio Date", value: "date", sortable: true },
        { text: "Invoice Date", value: "date", sortable: true },
        { text: "Customer Name", value: "name" },
        { text: "Status", value: "edit" },
      ],
    };
  },
  created() {
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "buyers",
        this.$root.$firebaseRefs.buyer
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "sellers",
        this.$root.$firebaseRefs.seller
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "firms",
        this.$root.$firebaseRefs.firm
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "portfolios",
        this.$root.$firebaseRefs.portfolio
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "buyerById",
        this.$root.$firebaseRefs.buyer
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "sellerById",
        this.$root.$firebaseRefs.seller
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
    this.$bindAsObject(
      "productById",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "termsAndConditions",
      this.$root.$firebaseRefs.termsAndConditions
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "bankById",
      this.$root.$firebaseRefs.account
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "firmInfrastructure",
      this.$root.$firebaseRefs.firmInfrastructure
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    ...mapGlobalGetters({ units: "productUnit" }),
    productListByBrand() {
      let prod = this.products.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          (!this.multiFirm
            ? this.selectedFirm
              ? item["firm"] === this.selectedFirm
              : false
            : true)
        );
      });
      prod.map((p, index) => {
        let productsWithSimilarCompostion = this.products.filter((item) => {
          return (
            item[".key"] == p[".key"] ||
            (item["brand"] === this.selectedBrand &&
              (!!item["composition"]
                ? _.isEqual(item["composition"], p["composition"])
                : false))
          );
        });
        prod[index]["similar"] = productsWithSimilarCompostion;
      });
      return prod;
    },
    portfoliosByBrand() {
      return this.portfolios.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          (this.selectedCustomer
            ? item.buyerId == this.selectedCustomer
            : true) &&
          (this.statusFilter != "ALL"
            ? item.status == this.statusFilter
            : true) &&
          item.isPortfolio
        );
      });
    },
    getPortfolioCustomers() {
      return this.buyersByBrand.map((b) => {
        return {
          text: b.name,
          value: b[".key"],
        };
      });
    },
    buyersByBrand() {
      return this.buyers.filter((item) => {
        return item["brand"] === this.selectedBrand;
      });
    },
    sellersByBrand() {
      return this.sellers.filter((item) => {
        return item["brand"] === this.selectedBrand;
      });
    },
    firmsByBrand() {
      return this.firms
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (item.defaultFirm) {
            this.selectedFirm = item[".key"];
          }
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    isRestaurantBusiness() {
      if (this.selectedFirm) {
        let firm = this.firms.find((item) => item[".key"] == this.selectedFirm);
        if (firm.businessType == "Restaurant") {
          return true;
        }
      }
      return false;
    },
    isJewlBusiness() {
      if (this.selectedFirm) {
        let firm = this.firms.find((item) => item[".key"] == this.selectedFirm);
        if (firm.businessType == "Jwellery") {
          return true;
        }
      }
      return false;
    },
    floorList() {
      if (this.selectedFirm) {
        let firmInfrastructure = this.firmInfrastructure.find(
          (item) => item["firm"] == this.selectedFirm
        );
        return firmInfrastructure.floorDetails;
      }
      return [];
    },
    productInvoiceHeader() {
      let productInvoiceHeader = null;
      if (this.isJewlBusiness) {
        productInvoiceHeader = [
          { text: "Name", value: "Name" },
          { text: "Quantity", value: "Taxable" },
          { text: "Purity", value: "Taxable" },
          { text: "Gross Weight", value: "Taxable" },
          { text: "Date", value: "Taxable" },
          //   { text: "Unit", value: "HSN" },
          { text: "Rate", value: "rate" },
          { text: "Fetch Latest Rate", value: "total" },
        ];
      } else {
        productInvoiceHeader = [
          { text: "Name", value: "Name" },
          { text: "Quantity", value: "Taxable" },
          { text: "Date", value: "Taxable" },
          //   { text: "Unit", value: "HSN" },
          { text: "Rate", value: "rate" },
          { text: "Fetch Latest Rate", value: "total" },
        ];
      }
      return productInvoiceHeader;
    },
    productHeaderCreateInvoice() {
      let productInvoiceHeader = null;
      if (this.isJewlBusiness) {
        productInvoiceHeader = [
          { text: "Select", value: "Name" },
          { text: "Name", value: "Name" },
          { text: "Quantity", value: "Taxable" },
          { text: "Purity", value: "Taxable" },
          { text: "Gross Weight", value: "Taxable" },
          { text: "Date", value: "Taxable" },
          //   { text: "Unit", value: "HSN" },
          { text: "Rate", value: "rate" },
          { text: "Fetch Latest Rate", value: "total" },
        ];
      } else {
        productInvoiceHeader = [
          { text: "Select", value: "Name" },
          { text: "Name", value: "Name" },
          { text: "Quantity", value: "Taxable" },
          { text: "Date", value: "Taxable" },
          //   { text: "Unit", value: "HSN" },
          { text: "Rate", value: "rate" },
          { text: "Fetch Latest Rate", value: "total" },
        ];
      }
      return productInvoiceHeader;
    },
  },
  watch: {
    floorName: {
      handler(newVal, oldVal) {
        this.getTableList();
      },
      deep: true,
    },
    date: {
      handler(newVal, oldVal) {
        this.items[0].date = new Date(newVal).toISOString().substr(0, 10);
      },
      deep: true,
    },
    selectAll  :{
      handler(newVal, oldVal) {
        this.selectedPortfolio.items.map((i,index)=>{
          this.selectedPortfolio.items[index]['selected'] = this.selectAll;
        })
      },
      deep: true,
    }
  },
  methods: {
    fetchLatestRate(item) {
      let prod = this.products.find((item1) => item1[".key"] == item.productId);
      item.rate = Number.parseFloat((prod && prod.sellingPrice) || 0);
    },
    getTermsAndConditions(invoiceData) {
      let termsAndConditions = this.termsAndConditions.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["firm"] === invoiceData.firm
      );
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.bankById[bankId];
            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      return termsAndConditions;
    },
    getAddress(item) {
      if (!item) {
        return "";
      }
      let address =
        (item.village ? item.village + " - " : "") +
        (item.block ? item.block + " - " : "") +
        (item.tehsil ? item.tehsil + " - " : "") +
        (item.district ? item.district + " - " : "") +
        (item.state ? item.state + " - " : "") +
        (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    calculateGSTInvoice(currentUser, invoice, firm) {
      let SGST_val = 0;
      let CGST_val = 0;
      let IGST_val = 0;
      invoice.items &&
        invoice.items.map((item, index) => {
          let prod = this.products.filter(
            (p) => p[".key"] === item["productId"]
          )[0];
          item["taxableGST_rate"] = prod["taxableGST_rate"];
          item.HSN_code = prod["HSN_code"];
          item.basicPrice = Number.parseFloat(
            item.rate * item.quantity
          ).toFixed(2);
          item.GSTValue = Number.parseFloat(
            item.basicPrice * (parseFloat(item.taxableGST_rate) / 100)
          ).toFixed(2);
          item.totlePrice = Number.parseFloat(
            Number.parseFloat(item.basicPrice) +
              Number.parseFloat(item.GSTValue)
          ).toFixed(2);
          let GST = item["taxableGST_rate"];
          if (
            !currentUser.state ||
            (firm &&
              currentUser.state &&
              Number.parseFloat(GST) &&
              firm.state === currentUser.state)
          ) {
            item["CGST_val"] = item["GSTValue"] / 2;
            item["CGST"] = GST / 2;
            item["SGST_val"] = item["GSTValue"] / 2;
            item["SGST"] = GST / 2;
            item["IGST"] = 0;
            item["IGST_val"] = 0;
          } else {
            item["IGST"] = GST;
            item["CGST"] = 0;
            item["SGST"] = 0;
            item["IGST_val"] = item["GSTValue"];
            item["CGST_val"] = 0;
            item["SGST_val"] = 0;
          }
          SGST_val += parseFloat(item["SGST_val"]);
          CGST_val += parseFloat(item["CGST_val"]);
          IGST_val += parseFloat(item["IGST_val"]);
        });
      return { SGST_val, CGST_val, IGST_val };
    },
    addPortfolioDialog() {
      this.portfolioDialog = true;
      this.productsToPortfolio = [];
      this.items = [
        {
          productName: null,
          productId: null,
          quantity: 1,
          unit: null,
          rate: 0,
          grossWeight: 0,
          purity: 100,
          isReturn: false,
          date: new Date().toISOString().substr(0, 10),
        },
      ];
      this.isEdit = false;
      this.invoicePortfolio = false;
      this.selectedBuyer = null;
      // this.selectedFirm = null;
      this.portfolioNumber = null;
      this.selectedPortfolio = null;
    },
    combinePortfolio() {
      if (confirm("Are you sure you want to combine selected Items?")) {
        let groupId = 1;
        let selectStatus = false;
        this.items.map((it, index) => {
          if (!it.isReturn) {
            groupId++;
            selectStatus = it.selected;
          }
          this.items[index]["groupId"] = groupId;
          this.items[index]["selected"] = selectStatus;
        });
        let combinedItems = this.items.filter(
          (i1) => !i1.isReturn && i1.selected
        );
        let unselectedItems = this.items.filter((i1) => !i1.selected);

        this.items
          .filter((i2) => i2.isReturn)
          .map((item) => {
            let index = _.findIndex(combinedItems, function (ci) {
              return (
                ci.productId == item.productId &&
                ci.groupId == item.groupId &&
                item.selected
              );
            });
            if (index > -1) {
              combinedItems[index].grossWeight += item.isReturn
                ? -item.grossWeight
                : item.grossWeight;
              // combinedItems[index].quantity += item.isReturn
              //   ? -item.quantity
              //   : item.quantity;
            }
          });
        let history = {
          date: this.selectedPortfolio.date,
          items: this.items,
        };
        if (this.selectedPortfolio.portfolioHistory) {
          this.selectedPortfolio.portfolioHistory.push(history);
        } else {
          this.selectedPortfolio.portfolioHistory = [history];
        }
        this.items = combinedItems.concat(unselectedItems);
        this.items.map((it, index) => {
          delete this.items[index].groupId;
          delete this.items[index].selected;
        });
      }
    },
    openHistory(item) {
      this.selectedPortfolio = item;
      this.portfolioHistory = true;
      this.historyStep = 1;
      this.modalMode = "history";
    },
    openOrignal(item) {
      this.selectedPortfolio = item;
      this.portfolioHistory = true;
      this.historyStep = 1;
      this.modalMode = "orignal";
    },
    openProd(item) {
      this.selectedPortfolio = item;
      this.invoicePortfolio = true;
    },
    getTotal(item) {
      let total = 0;
      item.items.map((i) => {
        total += Number.parseFloat(
          Number.parseFloat(i.rate) * Number.parseFloat(i.quantity)
        );
      });
      return total;
    },
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter((item) => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    getCustomerName(id) {
      let buyer = this.buyerById[id];
      let seller = this.sellerById[id];
      if (!buyer && !seller) {
        return "DELETED CUSTOMER";
      }
      return buyer ? buyer.name : seller.name;
    },
    isShopUserExists(id) {
      let buyers = this.buyers.filter((item) => item.shopUserId == id);
      if (!buyers.length) {
        return false;
      }
      return true;
    },
    getShopUserName(id) {
      let buyers = this.buyers.filter((item) => item.shopUserId == id);
      if (!buyers.length) {
        return "DELETED CUSTOMER";
      }
      return buyers[0].name;
    },
    // addToBucket() {
    //   let tempIts = this.items;
    //   this.items = [];
    //   this.productsToPortfolio.map((prod, index) => {
    //     if (typeof prod == "string") {
    //       this.productsToPortfolio.splice(index, 1);
    //     }
    //   });
    //   this.productsToPortfolio.map((prod, index) => {
    //     let selectedProd = tempIts.filter(
    //       (item) => item["productId"] == prod[".key"]
    //     )[0];
    //     let itemToAdd = {
    //       productName: prod.name,
    //       similar: prod.similar,
    //       productId: prod[".key"],
    //       quantity:
    //         selectedProd && selectedProd.quantity ? selectedProd.quantity : 1,
    //       unit:
    //         selectedProd && selectedProd.unit ? selectedProd.unit : prod.unit,
    //       rate:
    //         selectedProd && selectedProd.rate
    //           ? selectedProd.rate
    //           : this.isBuyer
    //           ? prod["sellingPrice"] || 0
    //           : prod["purchasingPrice"] || 0,
    //       grossWeight: 0,
    //       purity: 100,
    //       isReturn: false,
    //       date: new Date().toISOString().substr(0, 10),
    //     };
    //     if (this.multiFirm) {
    //       itemToAdd["firm"] = prod.firm;
    //     }
    //     this.items.push(itemToAdd);
    //   });
    // },
    restructureProductList(indexMain) {
      let buyer = this.selectedBuyer;
      this.items.map((item, index) => {
        if (indexMain ? index == indexMain : true) {
          let prod = this.products.filter(
            (item1) =>
              item1["name"] == item.productName &&
              item1["brand"] === this.selectedBrand
          )[0];
          this.items[index]["productName"] = prod.name;
          this.items[index]["productId"] = prod[".key"];
          this.items[index]["quantity"] = 1;
          this.items[index]["unit"] = prod.unit;
          this.items[index]["rate"] = this.isBuyer
            ? prod["sellingPrice"] || 0
            : prod["purchasingPrice"] || 0;
          if (this.multiFirm) {
            this.items[index]["firm"] = prod.firm;
          }
          if(buyer && buyer.category && prod.sellingPriceByCategories && prod.sellingPriceByCategories[buyer.category]) {
            this.items[index]['rate'] = prod.sellingPriceByCategories[buyer.category]
          }
          if (this.isRestaurantBusiness) {
            let call = 0;
            if (this.items.length > 1) {
              call = Math.max.apply(
                Math,
                this.items.map(function (o) {
                  return o.call || 0;
                })
              );
            }
            if (!this.isCallAdded) {
              call++;
              this.isCallAdded = !this.isCallAdded;
            }
            this.items[index]["call"] = call;
          }
        }
      });
    },
    getTableList() {
      this.tableList = this.floorList.find(
        (item) => item.name == this.floorName
      ).tables;
    },
    addProd(product, index) {
      let itemToAdd = null;
      if (product) {
        itemToAdd = { ...product };
        itemToAdd.isReturn = true;
        itemToAdd.date = new Date().toISOString().substr(0, 10);
        this.items.splice(index + 1, 0, itemToAdd);
      } else {
        itemToAdd = {
          productName: null,
          productId: null,
          quantity: 1,
          unit: null,
          rate: 0,
          grossWeight: 0,
          purity: 100,
          isReturn: false,
          date: new Date(this.date).toISOString().substr(0, 10),
        };
        this.items.push(itemToAdd);
      }
    },
    removeProd(index) {
      this.items.splice(index, 1);
    },
    getCurrentFirmState() {
      let firm = this.firms.filter(
        (item) => item[".key"] == this.selectedFirm
      )[0];
      return firm["state"];
    },
    addCustomer: function (e) {
      let obj = {
        name: e.target.value,
        brand: this.selectedBrand,
        state: this.getCurrentFirmState(),
      };
      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    addShopUser(portfolio) {
      if (confirm("Are you sure you want to create buyer?")) {
        let obj = {
          name: portfolio.shopPortfolioUserName,
          shopUserId: portfolio.shopPortfolioUserId,
          brand: this.selectedBrand,
          state: this.getCurrentFirmState(),
        };
        this.$root.$firebaseRefs.buyer.push(obj);
      }
    },
    createInvoice() {
      let key = this.selectedPortfolio[".key"];
      delete this.selectedPortfolio[".key"];

      if (
        !this.selectedPortfolio.buyerId &&
        this.selectedPortfolio.shopPortfolioUserId
      ) {
        let buyer = this.buyers.filter(
          (item) =>
            item.shopUserId == this.selectedPortfolio.shopPortfolioUserId
        )[0];
        if (buyer) {
          this.selectedPortfolio["buyerId"] = buyer[".key"];
        } else {
          return;
        }
      }

      this.$root.$firebaseRefs.portfolio
        .child(key)
        .set(this.selectedPortfolio)
        .then((snap) => {
          this.selectedPortfolio = null;
          this.$router.push({ path: `/portfolio-to-invoice/${key}` });
          this.invoicePortfolio = false;
        });
    },
    cancelPortfolio(portfolio) {
      let key = portfolio[".key"];
      delete portfolio[".key"];
      portfolio["status"] = "CANCELLED";
      this.$root.$firebaseRefs.portfolio
        .child(key)
        .set(portfolio)
        .then((snap) => {});
    },
    editPortfolio(portfolio) {
      if (portfolio.multiFirm) {
        this.multiFirm = true;
      }
      this.productsToPortfolio = [];
      this.portfolioDialog = true;
      this.isEdit = true;
      this.items = portfolio.items;
      this.items.map((i, index) => {
        this.items[index]["date"] = new Date(i.date)
          .toISOString()
          .substr(0, 10);
      });
      this.selectedFirm = portfolio.firm;
      (this.date = new Date(portfolio.date).toISOString().substr(0, 10)),
        (this.portfolioNumber = portfolio.portfolioNumber),
        (this.selectedPortfolio = { ...portfolio });
      this.isBuyer = portfolio.isBuyer;
      if (portfolio.isBuyer) {
        this.selectedBuyer = this.buyerById[portfolio.buyerId];
      } else {
        this.selectedBuyer = this.sellerById[portfolio.buyerId];
      }
      if (this.isRestaurantBusiness) {
        this["floorName"] = portfolio.floorName;
        this["tableName"] = portfolio.tableName;
      }
    },
    addPortfolio() {
      this.items.map((i, index) => {
        if (!i.productName) {
          this.items.splice(index, 1);
        } else {
          this.items[index]["date"] = new Date(i.date).getTime();
        }
      });
      let portfolioObj = {
        buyerId: this.selectedBuyer[".key"],
        isBuyer: this.isBuyer,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        portfolioNumber: this.portfolioNumber,
        items: this.items,
        isPortfolio: true,
      };
      //   status: 'IN PROGRESS'
      // }
      // this.$root.$firebaseRefs.portfolio.push(portfolioObj);
      if (this.multiFirm) {
        portfolioObj["multiFirm"] = true;
      }
      if (this.isRestaurantBusiness) {
        portfolioObj["floorName"] = this.floorName;
        portfolioObj["tableName"] = this.tableName;
      }
      let history = {
        date: new Date(this.date).getTime(),
        items: this.items,
      };
      if (this.isEdit) {
        if (this.selectedPortfolio.portfolioHistory) {
          portfolioObj["portfolioHistory"] = this.selectedPortfolio.portfolioHistory;
          portfolioObj["portfolioHistory"].push(history);
        } else {
          portfolioObj["portfolioHistory"] = [history];
        }
        portfolioObj["status"] = this.selectedPortfolio["status"];
        portfolioObj["buyerId"] = this.selectedPortfolio["buyerId"];
        this.$root.$firebaseRefs.portfolio
          .child(this.selectedPortfolio[".key"])
          .set(portfolioObj)
          .then((snap) => {
            this.isEdit = false;
          });
      } else {
        portfolioObj["status"] = "IN PROGRESS";
        portfolioObj["portfolioHistory"] = [history];
        this.$root.$firebaseRefs.portfolio.push(portfolioObj);
      }
      this.isCallAdded = false;
      this.portfolioDialog = false;
      this.selectedBuyer = null;
      this.isBuyer = true;
      this.items = [];
      this.productsToPortfolio = [];
    },
    deletePortfolio(portfolio) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.portfolio.child(portfolio[".key"]).remove();
      }
    },
  },
};
</script>
<style>
.status-filter.v-select .v-select__selections,
.status-filter.v-icon {
  color: #fff !important;
}
.status-filter.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #fff;
}
</style>
<style scoped>
.invoice-stepper {
  border: 1px solid #01579b;
  border-radius: 4px;
  background: #fafafa;
}
</style>


// WEBPACK FOOTER //
// src/components/PortfolioManagement/PortfolioManagement.vue